import { useState } from 'react';
import { useNotifications } from './NotificationsProvider';

const DISMISSED_STORAGE_KEY = 'tizok:notifications-banner-dismissed';

function readDismissedPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(DISMISSED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function NotificationsPermissionBanner() {
  const { permission, requestPermission } = useNotifications();
  const [dismissed, setDismissed] = useState(readDismissedPreference);

  if (permission !== 'default' || dismissed) return null;

  function dismissBanner() {
    setDismissed(true);
    try {
      window.localStorage.setItem(DISMISSED_STORAGE_KEY, 'true');
    } catch {
      /* storage disabled - dismiss for this session only */
    }
  }

  return (
    <div className="notifications-banner" role="status">
      <span>Enable browser notifications for @-mentions?</span>
      <div className="notifications-banner-actions">
        <button
          type="button"
          className="notifications-banner-enable"
          onClick={() => {
            void requestPermission();
          }}
        >
          Enable
        </button>
        <button
          type="button"
          className="notifications-banner-dismiss"
          onClick={dismissBanner}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
